import DerivAPI from "@deriv/deriv-api/dist/DerivAPI";
import {configDeriv} from "../constants/deriv";

export const Deriv = ()=>{
    return new DerivAPI({app_id:configDeriv.appid,endpoint:configDeriv.endpoint,lang:configDeriv.lang});
}